<vs-dialog
  [config]="{ 
    disableBackdropDismiss: submitting,
    dialogContainerClass: 'w-[80vw] max-w-lg'
  }"
>
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      showDivider: true,
      hideCloseButton: submitting,

      icon: 'bar-chart-square-plus',
      iconTheme: 'primary',

      title: 'Create a new dashboard',
      subtitle: 'Create a new dashboard to organize your data and share important information with your colleagues'
    }"
  ></vs-dialog-header>

  <form class="pt-3 px-2 flex flex-col gap-3" [formGroup]="form">
    <vs-form-field [config]="{ label: 'Dashboard Title' }">
      <input required vsInput type="text" placeholder="My Dashboard" formControlName="title" />
    </vs-form-field>

    <vs-form-field [config]="{ label: 'Dashboard Description' }">
      <textarea required vsInput placeholder="My dashboard's description" formControlName="description"></textarea>
    </vs-form-field>

    <vs-form-field [config]="{ label: 'Embed URL' }" class="-mt-1">
      <input required vsInput type="url" placeholder="https://..." formControlName="embedUrl" />
    </vs-form-field>

    <vs-form-field
      *ngIf="form.controls.isDefault.enabled"
      class="mt-1"
      appearance="horizontal"
      [config]="{
        label: 'Default Dashboard',
        description: 'Make this the default dashboard for all users'
      }"
    >
      <div class="flex items-center gap-2 justify-end">
        <input vsInput id="is-default-checkbox" type="checkbox" appearance="toggle" formControlName="isDefault" />
        <label vsCheckboxLabel for="is-default-checkbox">Default</label>
      </div>
    </vs-form-field>
  </form>

  <div class="mt-8 px-2 pb-3 flex justify-end gap-3">
    <button vs-button appearance="outline" [disabled]="submitting" (click)="close()">Cancel</button>
    <button vs-button theme="primary" [disabled]="submitting || form.invalid" (click)="submit()">
      Create dashboard
    </button>
  </div>
</vs-dialog>
